import { AnalyticsObject } from "app/analytics/utils/generateAnalyticsObject"
import Head from "next/head"
import Script from "next/script"
import { PropsWithChildren, ReactNode, useMemo } from "react"
import Analytics from "../components/Analytics"
import { useGTMTokenFromContext } from "../providers/SystemInfoProvider"
import React from "react"

const Layout = ({
  title,
  analyticsObject,
  children,
}: PropsWithChildren<{
  title?: ReactNode
  analyticsObject?: Partial<AnalyticsObject>
}>) => {
  const token = useGTMTokenFromContext()

  const fullAnalyticsObject = useMemo<Partial<AnalyticsObject>>(() => {
    return analyticsObject || {}
  }, [analyticsObject])

  return (
    <>
      <Head>
        {/* eslint-disable-next-line @stringtale/no-unwrapped-jsx-text */}
        <title>{title ? `${title} - 123ZING` : "123ZING"}</title>
        <link rel="icon" href="/favicon.ico?v=1692089659" />
      </Head>
      {token ? (
        <Script id="google-tag-manager" strategy="afterInteractive">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${token}');`}
        </Script>
      ) : null}
      <Analytics analyticsObject={fullAnalyticsObject} />
      {children}
    </>
  )
}

export default Layout
